const pruneEmpty = (obj) => Object.entries(obj)
    .map(([k, v]) => [k, v && typeof v === "object" ? pruneEmpty(v) : v])
    //@ts-ignore
    .reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});

export { pruneEmpty };
